/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { StyleSheet } from 'react-native';

export const styles = {
	safeArea: {
		flex: 1,
		flexGrow: 1,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#fff',
	},
	errorMsg: {
		minHeight: 50,
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
	},
		error: {
			color: 'red',
		},
		errorIcon: {
			color: 'red',
			marginRight: 10,
		},
	pickerContainer: {
		borderRadius: 5,
		borderWidth: 1,
		marginTop: 10,
		width: '100%',
	},
		picker: {
			width: '100%',
		},
		pickerItem: {
			flex: 1,
		},
		pickerTitle: {
			width: 240,
		},
	nativePickerContainer: {
		borderRadius: 5,
		borderWidth: 1,
	},
		nativePicker: {
			paddingLeft: 20,
			paddingRight: 20,
			paddingTop: 10,
			paddingBottom: 10,
			fontSize: 18,
		},
		nativePickerIconContainer: {
			top: 10,
			right: 10,
		},
		nativePickerIcon: {
			fontSize: 23,
		},
	form: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	textInput: {
		borderRadius: 5,
		borderWidth: 1,
		backgroundColor: '#fff',
		borderColor: '#888',
		width: '100%',
		paddingLeft: 20,
		paddingRight: 20,
		paddingTop: 10,
		paddingBottom: 10,
		marginBottom: 10,
		fontSize: 18,
	},
	gridPanel: {
		flex: 1,
	},
		gridList: {
			backgroundColor: '#e2e2e2',
		},
		gridListItem: {
			backgroundColor: '#fff',
			borderBottomColor: '#999',
		},
	toolbar: {
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		margin: 0,
		padding: 10,
		borderTopWidth: 1,
		borderTopColor: '#ccc',
		backgroundColor: '#eee',
		borderBottomWidth: 1,
		borderBottomColor: '#ccc',
	},
		toolbarTop: {
			alignSelf: 'flex-start',
		},
		toolbarBottom: {
			alignSelf: 'flex-end',
		},
		toolbarRow: {
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
		},
	pagination: {
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
	},
		paginationRow: {
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
		},
		paginationButton: {
			width: 30,
			height: 30,
			marginLeft: 3,
			marginRight: 3,
			alignSelf: 'center',
			justifyContent: 'center',
			backgroundColor: '#ddd',
		},
		paginationButtonDisabled: {
			backgroundColor: '#eee',
		},
		paginationButtonIcon: {
			width: 30,
			height: 30,
			fontSize: 20,
			padding: 0,
			paddingTop: 5,
			justifyContent: 'center',
			textAlign: 'center',
			color: '#000',
			backgroundColor: 'transparent',
		},
		paginationButtonIconDisabled: {
			color: '#ccc',
		},
};
export default StyleSheet.create(styles);
